import { AxiosError } from 'axios'
import { ENDPOINT_SUPER_AGENT } from '../config'
import type { SuperAgentTokenStatus } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Reads the non-secret status of the workspace's Super Agent bot token. Returns
 * `provisioned: false` when AI is disabled, the caller lacks permission, or no
 * token exists yet.
 */
const getSuperAgentToken = async (workspaceSlug: string): Promise<SuperAgentTokenStatus> => {
  try {
    const response = await AuthAxios.get<SuperAgentTokenStatus>(
      `${ENDPOINT_SUPER_AGENT}/${workspaceSlug}/super-agent/token`,
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && (error.response?.status === 403 || error.response?.status === 404)) {
      return { provisioned: false }
    }
    throw error
  }
}

export default getSuperAgentToken
